import '../Payroll.css'
import { clearSettlementProcess } from "../../../context/PayrollProcess/SettlementActions";
import { DELETE_SETTLEMENTPAYROLL, GET_ALL_SETTLEMENTPAYROLL } from "../../../Querys/querys";
import { Dialog, DialogContent } from "@material-ui/core"
import { TextField } from '@material-ui/core';
import { useMutation } from "@apollo/client";
import { useState, useContext } from "react";
import Box from '@mui/material/Box';
import SettlementPayrollProcessContext from "../../../context/PayrollProcess/SettlementPayrollProcessContext";
import styles from './PayrollModals.module.css'


const EliminaSettlement = (props: any) => {
    const { state, dispatch } = useContext(SettlementPayrollProcessContext)
    const [activo, setactivo] = useState(false)

    const [deletePayroll] = useMutation(DELETE_SETTLEMENTPAYROLL, {
        refetchQueries: [{ query: GET_ALL_SETTLEMENTPAYROLL }],
    });

    const handleChange = (e: any) => {
        if (e.target.value === 'ELIMINAR') {
            setactivo(true)
        } else {
            setactivo(false)
        }
    }

    const handleDelete = async () => {
        const idPayroll = state._id
        deletePayroll({
            variables: {
                deleteSettlementPayrollId: state._id
            }
        })
        handleClose()
    }

    const handleClose = () => {
        clearSettlementProcess({}, dispatch)
    }


    return (
        <Dialog aria-labelledby='costumized-dialog-title' open={state.deleteModal} fullWidth={false} onClose={handleClose} maxWidth={"md"}>
            <div className={styles.em_container}>
                <div className={styles.contenedorCerrarModal}>
                    <div
                        className={styles.cerrarModal}
                        onClick={() => handleClose()}>
                    </div>
                </div>
                <div className={styles.contenedorPrincipal}>
                    <div className={styles.iconoEliminar}>
                    </div>
                    <div className={styles.em_titulo}>
                        ¿Confirmas eliminar esta baja?
                    </div>
                    <div className={styles.em_mensajePrtincipal}>
                        <span>Una vez eliminado no podrás recuperar la información</span>
                        <br />
                        <span className={styles.em_textoPrincipal}>Escribe ELIMINAR para confirmar</span>
                    </div>
                    <div>
                        <input
                            className={styles.input}
                            type="text"
                            onChange={(e) => handleChange(e)}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.em_contenedorBotones}>
                <button
                    className={styles.em_botonCancelar}
                    onClick={() => handleClose()}
                >
                    Cancelar
                </button>
                {(activo === true ?
                    <button
                        className={styles.em_botonConfirmarActivo}
                        onClick={() => handleDelete()}
                    >
                        <div className={styles.em_iconoConfirmarEliminar}></div>
                        <div>
                            Confirmar
                        </div>
                    </button>
                    :
                    <button className={styles.em_botonConfirmarInactivo}>
                        <div className={styles.em_iconoConfirmarEliminar}></div>
                        <div>
                            Confirmar
                        </div>
                    </button>
                )}

            </div>
        </Dialog>
    )
}

export default EliminaSettlement